import styled from 'styled-components';

import { BaseStyledComponentProps, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface CellProps {
	isFirst: boolean;
}

interface IconProps extends BaseStyledComponentProps {
	isChecked: boolean;
}

const Wrapper = styled('div')`
	display: table;
	width: 100%;
	margin-bottom: -4px;
`;

const Row = styled('div')`
	display: table-row;
`;

const Cell = styled('div')`
	box-sizing: border-box;
	display: table-cell;
	height: 60px;
	padding: 10px 15px;
	border-bottom: 1px solid ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 11.9)};
	vertical-align: middle;

	${(props: CellProps) => props.isFirst && `
		width: 1px;
		white-space: nowrap;
	`}
`;

const Label = styled('div')`
	padding-right: 20px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 59.5)};
	text-transform: capitalize;
`;

const Icon = styled('div')`
	box-sizing: border-box;
	width: 30px;
	height: 30px;
	border-radius: 50%;

	${({ isChecked, theme }: IconProps) => !isChecked && `border: 2px solid ${hexToRgba(theme.primary.strongColor, 11.9)};`}

	input {
		display: none;
	}

	label {
		display: block;
		width: 30px;
		height: 30px;
		cursor: pointer;
	}

	svg {
		width: 30px;
		height: 30px;
		fill: ${NewStyleColor.VibrantGreen};
	}
`;

export {
	Wrapper,
	Row,
	Cell,
	Label,
	Icon,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/CRMSelector/styles.ts